/**
 * Maps sidebar menu labels (legacy `activeMenu` / localStorage keys) to URL paths.
 * Every authenticated screen lives under `/` with a stable path segment.
 */

/** @type {Record<string, string>} menuId -> path without leading slash; '' means dashboard index */
export const MENU_TO_PATH = {
  Dashboard: '',
  Orders: 'orders',
  Stock: 'stock',
  Products: 'products',
  Designs: 'designs',
  Feeders: 'masters/feeders',
  Colors: 'masters/colors',
  'Production Units': 'masters/production-units',
  Categories: 'insights/categories',
  'Sub Categories': 'insights/sub-categories',
  Concepts: 'insights/concepts',
  'Admin User': 'users/admin',
  Brokers: 'users/brokers',
  Parties: 'users/parties',
  'Butta Cutting Parties': 'users/butta-cutting-parties',
  'Mill Finish Parties': 'users/mill-finish-parties',
  'Border Cutting Parties': 'users/border-cutting-parties',
  'Handwork Parties': 'users/handwork-parties',
  'Transport parties': 'users/transport-parties',
  Roles: 'security/roles',
  'Assign Roles': 'security/assign-roles',
  Settings: 'settings',
};

/** path without leading slash -> menuId */
export const PATH_TO_MENU = Object.fromEntries(
  Object.entries(MENU_TO_PATH).map(([menu, slug]) => [slug === '' ? '' : slug, menu])
);

/** Same normalisation as legacy Dashboard localStorage migration. */
export function normalizeMenuId(id) {
  if (!id || id === 'Dashboard') return 'Dashboard';
  if (id === 'KHATA') return 'Production Units';
  if (id === 'Bleaching Parties') return 'Butta Cutting Parties';
  if (id === 'Finishing Parties') return 'Mill Finish Parties';
  if (id === 'Sales User') return 'Dashboard';
  return id;
}

/** @param {string} menuId */
export function pathForMenu(menuId) {
  const m = normalizeMenuId(menuId);
  const slug = MENU_TO_PATH[m];
  if (slug === undefined) {
    return '/settings';
  }
  if (slug === '') return '/';
  return `/${slug}`;
}

/**
 * @param {string} pathname e.g. '/orders' or '/'
 * @returns {string} menu id for sidebar highlight
 */
export function menuFromPathname(pathname) {
  const trimmed = pathname.replace(/\/+$/, '') || '/';
  const key = trimmed === '/' ? '' : trimmed.slice(1);
  return PATH_TO_MENU[key] || 'Dashboard';
}
